<template>
  <div
    :class="{
      'home-page-header': true,
      'home-page-header-test': !isRecommend,
      abTestV3_5
    }"
  >
    <mobile-header
      ref="mobileHeader"
      :alwaysShow="true"
      :hideLeft="true"
      :customBackgroundColor="bgColor"
      borderBottom="0 none"
    >
      <div class="header-content" slot="navTitle">
        <div class="header-l">
          <template v-if="!isSticky">
            <img
              v-if="abTestV3_5"
              @click="navGoback"
              class="back-btn"
              src="~/images/platform/homepage/homepage-back-test.png"
            />
            <img
              v-else
              @click="navGoback"
              class="back-btn"
              src="~/images/platform/homepage/homepage-back.png"
            />
          </template>
          <template v-if="isSticky">
            <img
              @click="navGoback"
              class="back-btn"
              src="~/images/platform/homepage/homepage-back-test.png"
            />
            <img class="avatar" :src="basicInfo.avatar | imgZip(100)" alt="" />
            <div class="info">
              <div :class="{ name: true, 'name-sticky': isSticky }">
                {{ basicInfo.nickname }}
              </div>
              <div class="tags-view" v-if="zxProTeacher || qingsuLevel">
                <div v-if="zxProTeacher" class="zxteacher">
                  <i></i>
                  {{ zxProTeacher.name }}
                </div>
                <div class="qingsu-level" v-if="qingsuLevel">
                  <img
                    :src="
                      require(`../../../../images/platform/homepage/icon-level-${qingsuLevel}.png`)
                    "
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="header-name" v-if="abTestV3_5 && !isSticky">
          {{ basicInfo.nickname }}
        </div>
        <div class="header-r">
          <template v-if="isSticky">
            <p
              class="btn-base btn-follow"
              :class="{ 'qingsu-own': isQingtingTeacher && !isConsultTeacher }"
              v-if="!isOwner && !hasFollow"
              @click="toggleFollow"
            >
              <span class="icon-follow-add"></span>
              <span>关注</span>
            </p>
            <template v-else>
              <div class="more-wrp" @click="onMoreClick">
                <img src="~images/platform/homepage/homepage-more-test.png" />
              </div>
              <div class="more-wrp" @click="onEditClick" v-if="isShowEditBtn">
                <img src="~images/platform/homepage/header-edit-test.png" />
              </div>
            </template>
            <img
              class="share"
              src="~images/platform/homepage/homepage-share-test.png"
              @click="share"
            />
          </template>

          <template v-else>
            <div class="more-wrp" @click="onMoreClick">
              <img
                v-if="abTestV3_5"
                src="~images/platform/homepage/homepage-more-test.png"
              />
              <img v-else src="~images/platform/homepage/homepage-more.png" />
            </div>
            <div class="more-wrp" @click="onEditClick" v-if="isShowEditBtn">
              <img
                v-if="abTestV3_5"
                src="~images/platform/homepage/header-edit-test.png"
              />
              <img v-else src="~images/platform/homepage/header-edit.png" />
            </div>
            <img
              v-if="abTestV3_5"
              class="share"
              src="~images/platform/homepage/homepage-share-test.png"
              @click="share"
            />
            <img
              v-else
              class="share"
              src="~images/platform/homepage/homepage-share.png"
              @click="share"
            />
          </template>
        </div>
      </div>
    </mobile-header>

    <morePanel
      v-model="isShowMore"
      @follow="toggleFollow"
      @edit="onEditClick"
    ></morePanel>
  </div>
</template>

<script>
import mobileHeader from 'component/qa/MobileHeader.vue'
import morePanel from 'component/platform/homepage/common/morePanel.vue'
import { getScrollTop } from 'lib/tools/utils.js'

export default {
  components: {
    morePanel,
    mobileHeader
  },
  props: {
    currentTab: {
      type: Object,
      default: () => {}
    },
    abTestV3_5: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowMore: false,
      isSticky: false
    }
  },
  computed: {
    loginUser() {
      return this.$store.getters['loginUser']
    },
    isOwner() {
      return +this.loginUser.id === +this.$route.params.userId
    },
    // 当前url访问的是否咨询师
    isConsultTeacher() {
      return this.$store.getters['homepage/isConsultTeacher']
    },
    isQingtingTeacher() {
      return this.$store.getters['homepage/isQingtingTeacher']
    },
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    // firstIdentity() {
    //   return this.$store.getters['homepage/firstIdentity']
    // },

    userRelation() {
      return this.$store.state.homepage.userRelation
    },
    // 是否已关注
    hasFollow() {
      return this.userRelation && +this.userRelation.follow === 1
    },

    isApp() {
      const { isYixinliApp, isZiXunApp, isZiXunShiApp } = this.$platform
      return isYixinliApp || isZiXunApp || isZiXunShiApp
    },
    isShowEditBtn() {
      if (this.isOwner) {
        if (
          (!this.isConsultTeacher && !this.isQingtingTeacher) ||
          !this.isApp
        ) {
          return false
        }
        return true
      }
      return false
    },
    // 是否专业咨询师
    zxProTeacher() {
      if (!this.isConsultTeacher) {
        return false
      }
      let { identities } = this.basicInfo
      identities = Array.isArray(identities) ? identities : []
      return identities.find(item => item.business === 'zixun_pro_teacher')
    },
    qingsuBaseInfo() {
      return this.basicInfo.qing_info || {}
    },
    qingsuLevel() {
      if (!this.isQingtingTeacher) {
        return ''
      }
      const { grade } = this.qingsuBaseInfo
      return (grade && grade.grade_level) || ''
    },
    bgColor() {
      if (this.abTestV3_5) {
        return '#fff'
      }
      return this.isSticky ? '#fff' : 'transparent'
    },
    scrollDistance() {
      return this.abTestV3_5 ? 210 : 100
    }
  },
  mounted() {
    window.addEventListener('scroll', this.watchTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.watchTop)
  },
  methods: {
    navGoback() {
      this.routerGoback()
    },
    toggleFollow(autoCancel) {
      this.$emit('follow', autoCancel)
    },
    share() {
      this.$trackEvent('newprofilepages_share', {})
      this.$emit('share')
    },
    // 供外部调用
    getMobileHeaderRef() {
      return this.$refs.mobileHeader
    },
    onMoreClick() {
      this.$trackEvent('newprofilepages_more', {})
      this.isShowMore = true
    },
    onEditClick() {
      this.$trackEvent('newprofilepages_edit', {})
      if (this.isConsultTeacher || this.isQingtingTeacher) {
        this.routerToStaic({
          path:
            this.currentTab.name === 'service'
              ? '/zx-settlement-baseInfoData'
              : '/qs-settlement-qualificationsData',
          query: {
            hideNavigationBar: 1
          }
        })
      } else {
        window.location.href = 'yixinli://open_edit_info'
      }
    },
    // 判断是否滚动条是否滚动
    watchTop() {
      const scrollTop = getScrollTop()
      this.isSticky = scrollTop > this.scrollDistance
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';
@import '~style/platform/homepage/userinfo.scss';

// ::v-deep .head-middle {
//   height: 100% !important;
// }
.home-page-header-test {
  position: absolute;
  &.abTestV3_5 {
    position: relative;
    ::v-deep .head-middle {
      position: relative !important;
    }
    ::v-deep .mobile-header,
    ::v-deep .fixed {
      height: 92px;
    }
  }
}
::v-deep .mobile-header .fixed {
  transition: background-color 0.3s;
  z-index: $hp_zIndex_bottomBar_and_header !important;
}
::v-deep .mobile-header,
::v-deep .mobile-header .fixed {
  height: 92px;
}
.header-content {
  height: 100%;
  color: initial;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-sizing: border-box;
  .header-l .back-btn,
  .share {
    width: 44px;
    height: 44px;
  }
  .header-l {
    display: flex;
    align-items: center;
    .avatar {
      width: 80px;
      height: 80px;
      border: 2px solid #ffffff;
      box-sizing: border-box;
      border-radius: 50%;
      object-fit: cover;
      margin-left: 18px;
    }
    .name {
      font-size: 28px;
      line-height: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .name-sticky {
      color: #21252d;
    }
    .info {
      margin-left: 20px;
    }
    .tags-view {
      display: flex;
      align-items: center;
      margin-top: 12px;
    }
    .qingsu-level {
      img {
        width: auto;
        height: 36px;
      }
    }
    .zxteacher {
      display: flex;
      align-items: center;
      height: 36px;
      background: #fcf0dc linear-gradient(180deg, #fef5e6 0%, #f5e6b2 100%);
      border-radius: 17px;
      padding-right: 12px;
      margin-right: 16px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a2762e;
      i {
        width: 30px;
        height: 30px;
        margin: 0 5px;
        background: url('~images/platform/homepage/zxteacher-tag-icon.png')
          center/30px 30px no-repeat;
      }
    }
  }
  .header-r {
    display: flex;
    align-items: center;
    .btn-follow {
      margin-right: 24px;
      &.qingsu-own {
        border: 1px solid #ff745b;
        color: #ff745b;
        background: transparent;
        .icon-follow-add {
          background: url('~images/platform/homepage/icon-qingsu-follow.png')
            no-repeat center/100%;
        }
      }
      .icon-follow-add {
        width: 14px;
        height: 14px;
        margin-right: 8px;
        background: url('~images/platform/homepage/nm-follow-add-btn.png')
          no-repeat center/100%;
      }
    }
  }
  .more-wrp {
    display: flex;
    align-items: center;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    // margin-right: 40px;
    margin-right: 28px;
    color: #ffffff;
    img {
      width: 44px;
      height: 44px;
      //   margin-right: 10px;
    }
  }
  .header-name {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 38px;
    font-weight: 600;
    color: #21252d;
    line-height: 38px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
